import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from 'api/api';

const TIMEOUT_MS = 15 * 60 * 1000; // 15 minutes
const EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click'];

// ==============================|| HOOK - SESSION TIMEOUT ||============================== //

export default function useSessionTimeout() {
  const navigate = useNavigate();

  const handleLogout = useCallback(() => {
    logout();
    navigate('/login', { replace: true });
  }, [navigate]);

  useEffect(() => {
    // Only run if user is logged in
    if (!localStorage.getItem('user')) return;

    let timer = setTimeout(handleLogout, TIMEOUT_MS);

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(handleLogout, TIMEOUT_MS);
    };

    EVENTS.forEach((e) => window.addEventListener(e, resetTimer));

    return () => {
      clearTimeout(timer);
      EVENTS.forEach((e) => window.removeEventListener(e, resetTimer));
    };
  }, [handleLogout]);
}
